'use client';

import { c as _c } from "react/compiler-runtime";
import useLiveSortState from '@module/helpers/live/useLiveSortState';
import useLiveViewModel from '@module/helpers/live/useLiveViewModel';
import BroadcastList from '@pc/components/molecules/broadcast/BroadcastList';
import BroadcastListSkeleton from '@pc/components/molecules/broadcast/BroadcastListSkeleton';
function LiveContainer() {
  const $ = _c(10);
  const {
    onlyNewBj,
    orderBy,
    onlyRealTimeYN
  } = useLiveSortState();
  let t0;
  if ($[0] !== onlyNewBj || $[1] !== onlyRealTimeYN || $[2] !== orderBy) {
    t0 = {
      onlyNewBj,
      orderBy,
      onlyRealTimeYN
    };
    $[0] = onlyNewBj;
    $[1] = onlyRealTimeYN;
    $[2] = orderBy;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const {
    data,
    isLoading,
    observerRef,
    fetchNextPage,
    hasNextPage
  } = useLiveViewModel(t0);
  if (isLoading) {
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <BroadcastListSkeleton />;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  if (!data?.pages?.length) {
    return null;
  }
  let t1;
  if ($[5] !== data.pages || $[6] !== fetchNextPage || $[7] !== hasNextPage || $[8] !== observerRef) {
    t1 = <div id="live-container" data-testid="live-page"><BroadcastList className="live-page-list mr-0" list={data.pages} observerRef={observerRef} fetchNextPage={fetchNextPage} hasNextPage={hasNextPage} /></div>;
    $[5] = data.pages;
    $[6] = fetchNextPage;
    $[7] = hasNextPage;
    $[8] = observerRef;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
}
export default LiveContainer;